export default __webpack_public_path__ + "static/media/handprint-6-7-page.201276cb.png";